import { render, staticRenderFns } from "./card.vue?vue&type=template&id=2ca4ff92&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4ff92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca4ff92')) {
      api.createRecord('2ca4ff92', component.options)
    } else {
      api.reload('2ca4ff92', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=2ca4ff92&scoped=true", function () {
      api.rerender('2ca4ff92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entity/card.vue"
export default component.exports